import MovieTimesPeriodeDaysItems from '../presents/MovieTimesPeriodeDaysItems';
import getFormatedDate from '../../../functions/getFormatedDate'
import getDateObj from '../../../functions/getDateObj'

const MovieTimesPeriodeDays = ({movieId, reducedVersion, itemStyle, periodesDays, generalSettings, noEmptyDays, translation, attributesColors, captionAttributes, hasFlyerCaptions, chosen_font, cinemaData, today, hideTheatres, colors, iconsColor, flyerDate}) => {
    const accentColor = colors.accent_color
    const accentColorDark = colors.accent_color_dark
    const themeColors = colors.theme_colors
    const style = {
        backgroundColor: accentColor
    }

    const borderStyle = {
        borderRadius: itemStyle === "single_movie_background" ? colors.border_radius_posters : 0,
        overflow: "hidden"
    }

    if(!periodesDays) {
        return  <div className='no-movietimes'>Für diese Woche leider keine Spielzeiten geplant.</div>
    }

    
    return _.keys(periodesDays).map((pDayKey, index) => {
        const dayFormarted = _.keys(periodesDays).length > 7 ? getFormatedDate(getDateObj(pDayKey), translation, false) : getFormatedDate(getDateObj(pDayKey), translation, flyerDate)
        const periodeDay = periodesDays[pDayKey]
        const hasPerformance = periodeDay.length > 0

        if((_.keys(periodesDays).length > 7 && !hasPerformance) || (_.keys(noEmptyDays).length < 7 && !hasPerformance)) {
            return ''
        }

        return reducedVersion ? (
            <div key={index} style={borderStyle} className={"movie-times-item triangle-right movie-times-item-" + index}>
                <div style={style} className={`date ${chosen_font}-text-xsmall-light`}>{dayFormarted}</div>
                <div style={itemStyle === "single_movie_background" ? style : {}} className="showtime-container">
                    {hasPerformance ? (
                        <MovieTimesPeriodeDaysItems
                            cinemaData={cinemaData}
                            reducedVersion={reducedVersion}
                            captionAttributes={captionAttributes}
                            hasFlyerCaptions={hasFlyerCaptions}
                            attributesColors={attributesColors}
                            themeColors={themeColors}
                            chosen_font={chosen_font}
                            movieId={movieId}
                            generalSettings={generalSettings}
                            accentColorDark={accentColorDark}
                            accentColor={accentColor}
                            iconsColor={iconsColor}
                            hideTheatres={hideTheatres}
                            performances={periodeDay} 
                            today={today} 
                            />
                        ) : (
                            ''
                        )}
                </div>
            </div> 
        ) : ( 
            <div key={index} style={borderStyle} className={"movie-times-item triangle-right movie-times-item-" + index}>
                <div style={style} className={`date ${chosen_font}-text-bold-grey-showtimes-desktop`}>{dayFormarted}</div>
                <div style={itemStyle === "single_movie_background" ? style : {}} className="showtime-container">
                    {hasPerformance ? (
                        <MovieTimesPeriodeDaysItems
                            movieId={movieId}
                            cinemaData={cinemaData}
                            chosen_font={chosen_font}
                            accentColorDark={accentColorDark}
                            generalSettings={generalSettings}
                            accentColor={accentColor}
                            iconsColor={iconsColor}
                            hideTheatres={hideTheatres}
                            performances={periodeDay} 
                            today={today} 
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div> 
        )
    })
}

export default MovieTimesPeriodeDays